import { cn } from "@/lib/utils";

/** "The Quantum MIND" — italic serif + bold sans lockup. */
export function BrandWordmark({
  className,
  size = "md",
}: {
  className?: string;
  size?: "md" | "lg";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-baseline gap-[0.28em] whitespace-nowrap",
        size === "lg" ? "text-[2.1rem]" : "text-2xl",
        className,
      )}
    >
      <span className="font-brand-serif text-[1.12em] font-medium italic tracking-tight">
        The Quantum
      </span>
      <span className="font-extrabold tracking-[0.04em]">MIND</span>
    </span>
  );
}
